import {
  Avatar,
  Box,
  Button,
  Divider,
  FormControl,
  InputLabel,
  styled,
  TextField,
  TextFieldProps,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { User } from "../../../Shared-ui/Types/User";
import { userInitial } from "../../../Shared-ui/Store/UserReducer/UserReducer";
import {
  isOnlyAlphabets,
  isWebsiteAddress,
} from "../../../Shared-ui/utils/Common/Common";
import {
  ValidateEmailIsOrg,
  ValidateIsEmail,
} from "../../../Shared-ui/utils/Auth/AuthHelpers";
import { useDispatch } from "react-redux";
import { setUserData } from "../../../Shared-ui/Store/UserReducer/UserActions";
import userContext from "../../../Shared-ui/Context/UserContext";
import AuthInstance from "../../../Services/AxiosInstance/AuthInstance";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { ME, USERS } from "../../../Services/Endpoint";
import { ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { ADMIN_USERS,ADMIN_ORGANIZATIONS } from "../../../Services/Endpoint";
import { SelectChangeEvent } from "@mui/material";

interface MyComponentProps { }

const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  '& input[type="number"]': {
    "-moz-appearance": "textfield", // Firefox
    "-webkit-appearance": "none", // Chrome/Safari
    appearance: "none", // Standard appearance reset
  },
  "& input::-webkit-outer-spin-button": {
    appearance: "none", // Disable the spinner
    margin: 0, // Reset the margin
  },
  "& input::-webkit-inner-spin-button": {
    appearance: "none", // Disable the spinner
    margin: 0, // Reset the margin
  },
}));

const UserProfileData: React.FC<MyComponentProps> = () => {
  const errorInitial = {
    email: { error: "", value: false },
    full_name: { error: "", value: false },
    organization: { error: "", value: false },
    website: { error: "", value: false },
    address: { error: "", value: false },
  };

  const dispatch = useDispatch();
  const { user, updateUserContext } = useContext(userContext);
  // Profile Image Upload
  const [image, setImage] = useState<string | null>(null);
  const [userForm, setUserForm] = useState<User>({
    ...userInitial,
    website: "",
    address: "",
    image: "",
  });
  const [userFormEr, setUserFormEr] = useState(errorInitial);
  const [organizations, setOrganizations] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
  const fetchOrganizations = async () => {
    try {
      const res = await BaseInstance.get(ADMIN_ORGANIZATIONS); 
      setOrganizations(res.data); 
    } catch (err) {
      console.error("Failed to fetch organizations", err);
    }
  };

  fetchOrganizations();
}, []);

const handleSelectChange = (event: SelectChangeEvent<string>) => {
  const { name, value } = event.target;
  setUserForm((prev) => ({ ...prev, [name!]: value }));
};

const selectedOrgName = organizations.find(
  (org) => org.id === userForm.organization_id
)?.name || userForm.organization_id; 

<TextField
  disabled
  value={selectedOrgName}
/>


  useEffect(() => {
    setUserForm(user);
  }, [user]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    const { name, value } = event.target;

    if (name === "image" && file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl); // Update state with the uploaded image URL
    } else {
      setUserForm((preVal) => ({ ...preVal, [name]: value }));
    }
  };

  const validateUserForm = () => {

    let error = 0
    const setError = (field: string, condition: boolean, message: string) => {
      if (condition) {
        setUserFormEr(prev => ({
          ...prev,
          [field]: { error: message, value: true }
        }));
        error += 1;
      } else {
        setUserFormEr(prev => ({
          ...prev,
          [field]: { error: "", value: false }
        }));
      }
    };


    // email valiadtion
    setError("email", !ValidateEmailIsOrg(userForm.email), "Please enter minum charater 4")
    setError("email", !userForm.email.trim(), "Please enter minum charater 4")

    // name validation
    setError("full_name", userForm.full_name.length < 4, "Please enter minum charater 4")

    // website validation
    setError("website", !isWebsiteAddress(userForm.website ? userForm.website : ""), "Please enter valid website url")


    return error === 0 ? true : false
  };

  const updateUser = async () => {
    if (validateUserForm()) {
      try {
        dispatch(StartLoading());
        const data = await BaseInstance.put(ME, userForm).then(
          (res) => res?.data
        );
        dispatch(ShowSuccess("user updated"));
        //  TO update user context after userform update
        updateUserContext();
      } catch (err) {
        console.log(err);
      } finally {
        dispatch(StopLoading());
      }
    }
  };

  return (
    <>
      <Typography variant="h6">Profile</Typography>
      <Typography variant="body2">
        Update your photo and personal details here.
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Box
        sx={{
          display: "flex",
          flexDirection: { md: "row", sm: "row", xs: "column" },
          mb: "30px",
          gap: "30px",
          alignItems: "center",
        }}
      >
        <Avatar
          src={image || undefined}
          sx={{
            width: 120,
            height: 120,
            borderRadius: "10px",
          }}
          alt="Profile Picture"
        />
        <Button
          disableElevation
          variant="contained"
          component="label"
          sx={{ textTransform: "none" }}
        >
          Upload Image
          <input
            type="file"
            name="image"
            hidden
            accept="image/*"
            onChange={handleChange}
          />
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { md: "row", sm: "column", xs: "column" },
          width: "100%",
          gap: "30px",
          mb: "30px",
        }}
      >
        <FormControl fullWidth variant="outlined" error={userFormEr.full_name.value}>
          <InputLabel
            htmlFor="full_name"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Name
          </InputLabel>
          <TextField
            id="full_name"
            name="full_name"
            value={userForm.full_name}
            placeholder="Name"
            onChange={handleChange}
            sx={{ background: "white" }}
            error={userFormEr.full_name.value}
            helperText={userFormEr.full_name.error}
          />
        </FormControl>

        <FormControl
          fullWidth
          variant="outlined"
          error={userFormEr.email.value}
        >
          <InputLabel
            htmlFor="email"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Business Email
          </InputLabel>
          <TextField
            id="email"
            name="email"
            value={userForm.email}
            placeholder="Email"
            onChange={handleChange}
            sx={{ background: "white" }}
            error={userFormEr.email.value}
            helperText={userFormEr.email.error}
          />
        </FormControl>
      </Box>
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: { md: "row", sm: "column", xs: "column" },
          width: "100%",
          gap: "30px",
          mb: "30px",
        }}
      >
        <FormControl
          fullWidth
          variant="outlined"
          error={userFormEr.organization.value}
        >
          <InputLabel
            htmlFor="organization"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Organization
          </InputLabel>
           <Select
              id="organization"
              name="organization_id"
              value={userForm.organization_id}
              onChange={handleSelectChange}
              displayEmpty
              sx={{ background: "white" }}
            >
            <MenuItem value="" disabled>Select organization</MenuItem>
                {organizations.map((org) => (
            <MenuItem key={org.id} value={org.id}>
                {org.name}
            </MenuItem>
                ))}
            </Select>

        </FormControl>

        <FormControl
          fullWidth
          variant="outlined"
          error={userFormEr.website.value}
        >
          <InputLabel
            htmlFor="website"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Website
          </InputLabel>
          <TextField
            id="website"
            name="website"
            onChange={handleChange}
            value={userForm.website}
            placeholder="Website"
            sx={{ background: "white" }}
            error={userFormEr.website.value}
            helperText={userFormEr.website.error}
          />
        </FormControl>
      </Box> */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { md: "row", sm: "column", xs: "column" },
          width: "49%",
          gap: "30px",
          mb: "30px",
        }}
      >
        {/* <FormControl
          fullWidth
          variant="outlined"
          error={userFormEr.address.value}
        >
          <InputLabel
            htmlFor="address"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Address
          </InputLabel>
          <TextField
            id="address"
            multiline
            name="address"
            onChange={handleChange}
            value={userForm.address}
            placeholder="Address"
            sx={{
              background: "white",
              "& textarea": {
                height: "100px", // Set a fixed height
                overflowY: "auto", // Enable vertical scrolling when content overflows
              },
            }}
            error={userFormEr.address.value}
            helperText={userFormEr.address.error}
          />
        </FormControl> */}
        <FormControl
          fullWidth
          variant="outlined"
        >
          <InputLabel
            htmlFor="user"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Super User
          </InputLabel>
          <StyledTextField
            id="user"
            name="user"
            type="text"
            disabled
            value={user.is_superuser ? "Yes" : "No"}
            // onChange={handleChange}
            placeholder="Phone"
            sx={{
              background: "white",
            }}
          />
        </FormControl>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          justifyContent: "flex-end",
        }}
      >
        <Button
          variant="contained"
          disableElevation
          size="large"
          sx={{
            textTransform: "capitalize",
            minWidth: "140px",
          }}
          onClick={updateUser}
        >
          Save
        </Button>
      </Box>
    </>
  );
};

export default UserProfileData;
